import { ESnapshotExists, EOrganization, Customer } from 'lib/types';

export const getIsAccountOnHold = (
  publisherOrganization: ESnapshotExists<EOrganization> | undefined,
  existingCustomer: ESnapshotExists<Customer> | null,
  {
    isPublisher
  }: {
    isPublisher: boolean;
  }
) => {
  if (existingCustomer) {
    if (existingCustomer.data().isAccountOnHold) {
      return {
        isAccountOnHold: true,
        onHoldMessage: isPublisher
          ? 'Customer account is on hold. Remove the hold from the customer to place notices.'
          : 'Customer account is on hold. Please contact the publisher to enable your account to place notices.'
      };
    }
  }

  if (
    publisherOrganization?.data().requireApprovalToPlaceOrders &&
    !isPublisher
  ) {
    return {
      isAccountOnHold: true,
      onHoldMessage:
        'This publisher requires approval to place notices. Please contact them to enable your account to place notices.'
    };
  }

  return {
    isAccountOnHold: false,
    onHoldMessage: undefined
  };
};
